
export default function Symbols() {
    const list = [];
    const alphabeticList = [];
    const addressList = [];
    let tag = 0;

    const load = (symbolFile) => {
        symbolFile
            .split("\n")
            .map(line => line.trim())
            .filter(line => line != "")
            .map(line => line.split(" "))
            .map(cols => ({
                address: parseInt(cols[1], 16),
                symbol: cols[2].substring(1),
                tag: tag++
            }))
            .forEach((x) => {
                list.push(x);
                alphabeticList.push(x);
                addressList.push(x);
            })

        alphabeticList.sort((a, b) => 
            a.symbol.toUpperCase() - b.symbol.toUpperCase());
        addressList.sort((a, b) => a.address - b.address);
    };

    const getAddress = (symbol) => {
        const c = list.filter(l => l.symbol == symbol);
        return c.length ? c[0].address : null;
    };

    const getClosestLeftSymbol = (address) => {
        let closest = { address: 0, symbol: 'unknown' };
        for (let item of list) {
            if ( ((address - item.address) > 0) && ((address - item.address) < (address - closest.address)) ) {
                closest = item;
            }
        }
        const rel = address - closest.address;
        return {
            symbolName: closest.symbol,
            symbolAddress: closest.address,
            rel: rel
        };
    };

    return {
        load: load,
        getAddress: getAddress,
        alphabeticList: alphabeticList,
        addressList: addressList,
        getClosestLeftSymbol: getClosestLeftSymbol
    }
}


// WEBPACK FOOTER //
// ./src/emu/symbols.js